import { RaceStockDisplayThreshold } from '@prisma/client'
import { VariantInventory } from 'domain/models/Inventory/VariantInventory'

export const getShowRaceStock = ({
  raceStockInventory,
  stockDisplayThreshold,
  stockDisplayThresholdValue,
  isWaitingList
}: {
  raceStockInventory: VariantInventory | null | undefined
  stockDisplayThreshold: RaceStockDisplayThreshold
  stockDisplayThresholdValue: number
  isWaitingList: boolean
}) => {
  if (!raceStockInventory || isWaitingList) {
    return false
  }

  if (stockDisplayThreshold === RaceStockDisplayThreshold.ALWAYS) {
    return true
  }

  if (stockDisplayThreshold === RaceStockDisplayThreshold.NEVER) {
    return false
  }

  if (stockDisplayThreshold === RaceStockDisplayThreshold.BELOW) {
    const availableStock =
      raceStockInventory.stockedQuantity - raceStockInventory.reserved

    // Return false if available stock is negative
    if (availableStock < 0) {
      return false
    }

    // Return true if available stock is below or equal to threshold
    return availableStock <= stockDisplayThresholdValue
  }

  return false
}
